"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CFB = void 0;
const CFBModule = require("cfb");
function resolveCfb() {
    if (typeof CFBModule.read === 'function') {
        return CFBModule;
    }
    const wrapped = CFBModule.default;
    if (wrapped !== undefined && typeof wrapped.read === 'function') {
        return wrapped;
    }
    const shape = Object.keys(CFBModule)
        .map((key) => `${key}:${typeof CFBModule[key]}`)
        .join(',');
    throw new Error(`cfb library surface not found on module namespace or default export (namespace: [${shape}])`);
}
exports.CFB = resolveCfb();
//# sourceMappingURL=cfb-interop.js.map